import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from './constants';
import PcrService from 'services/PcrService';

export const useProductCategories = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.STANDARD_EPD_PRODUCT_CATEGORIES],
    queryFn: () => PcrService.getRootCategories(),
    refetchOnWindowFocus: false,
  });
};

export const usePcrsOfProductCategory = (productCategoryId: string | undefined | null) => {
  return useQuery({
    queryKey: [QUERY_KEYS.STANDARD_EPD_PCRS, productCategoryId],
    queryFn: () =>
      PcrService.findPcr({
        productCategoryId,
        pcrType: 'PCR',
        isDisabled: false,
      }),
    refetchOnWindowFocus: false,
    enabled: !!productCategoryId,
  });
};

export const useCpcrsOfMainPcr = (pcrId: string | undefined | null) => {
  return useQuery({
    queryKey: [QUERY_KEYS.STANDARD_EPD_CPCRS, pcrId],
    queryFn: () =>
      PcrService.findPcr({
        pcrType: 'CPCR',
        mainPCRId: pcrId,
        isDisabled: false,
      }),
    refetchOnWindowFocus: false,
    enabled: !!pcrId,
  });
};
